<script>
  import Calendar from "./Calendar.svelte"
  import NotFound from "./NotFound.svelte"
  const routes = {
    // Wildcard parameter
    "/kalender/:type": Calendar,

    // Catch-all
    // This is optional, but if present it must be the last
    "*": NotFound,
  }

  import Router from "svelte-spa-router"

  import { onMount } from "svelte"
  import { chart } from "svelte-apexcharts"
  import queryString from "query-string"

  let parsed = {}

  if (typeof window !== "undefined") {
    parsed = queryString.parse(window.location.search)
  }
  let series = []
  let CurrentYearWithMonths, YearsWithMonths, CurrentYear, AllYears, mod
  mod = "m²"
  YearsWithMonths = {
    KVMLMYears: [
      {
        year: 2018,
        TotalKVMYear: 1282030.64,
        KVMYear: 1282030.64,
        KVMGNSSYear: 0,
        TotalLMYear: 58068.3,
        LMYear: 58068.3,
        LMGNSSYear: 0,
        Months: [
          {
            month: 1,
            monthtext: "Januar",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 2,
            monthtext: "Februar",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 3,
            monthtext: "Mars",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 4,
            monthtext: "April",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 5,
            monthtext: "Mai",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 6,
            monthtext: "Juni",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 7,
            monthtext: "Juli",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 8,
            monthtext: "August",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 9,
            monthtext: "September",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 10,
            monthtext: "Oktober",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 11,
            monthtext: "November",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 12,
            monthtext: "Desember",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
        ],
      },
      {
        year: 2019,
        TotalKVMYear: 1622766.19,
        KVMYear: 1622766.19,
        KVMGNSSYear: 0,
        TotalLMYear: 224985.1,
        LMYear: 224985.1,
        LMGNSSYear: 0,
        Months: [
          {
            month: 1,
            monthtext: "Januar",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 2,
            monthtext: "Februar",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 3,
            monthtext: "Mars",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 4,
            monthtext: "April",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 5,
            monthtext: "Mai",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 6,
            monthtext: "Juni",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 7,
            monthtext: "Juli",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 8,
            monthtext: "August",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 9,
            monthtext: "September",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 10,
            monthtext: "Oktober",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 11,
            monthtext: "November",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 12,
            monthtext: "Desember",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
        ],
      },
      {
        year: 2020,
        TotalKVMYear: 2278800.14,
        KVMYear: 1966528.04,
        KVMGNSSYear: 312272.1,
        TotalLMYear: 216367.83,
        LMYear: 216316.53,
        LMGNSSYear: 51.3,
        Months: [
          {
            month: 1,
            monthtext: "Januar",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 2,
            monthtext: "Februar",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 3,
            monthtext: "Mars",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 4,
            monthtext: "April",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 5,
            monthtext: "Mai",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 6,
            monthtext: "Juni",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 7,
            monthtext: "Juli",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 8,
            monthtext: "August",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 9,
            monthtext: "September",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 10,
            monthtext: "Oktober",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 11,
            monthtext: "November",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
          {
            month: 12,
            monthtext: "Desember",
            TotalKVMMonth: 0,
            KVMMonth: 0,
            KVMGNSSMonth: 0,
            TotalLMMonth: 0,
            LMMonth: 0,
            LMGNSSMonth: 0,
          },
        ],
      },
    ],
    updateddate: "2020-11-10T09:12:36.5022058+01:00",
  }
  let chartTypesList = [
    "M2",
    "M2GNSS",
    "TotalLM",
    "TotalM2",
    "TotalLMYear",
    "TotalM2Year",
    "TotalM2MonthsYears",
    "TotalLMMonthsYears",
  ]
  let timer = 6000
  let showLinks = false
  let title = ""
  let switchCharts = false
  let type = "none"
  let year = new Date().getFullYear()
  let chartType = "bar"
  if (parsed.showLinks) {
    showLinks = parsed.showLinks
  }
  if (parsed.type) {
    type = parsed.type
  }
  if (parsed.switchCharts) {
    switchCharts = parsed.switchCharts
  }
  if (parsed.chartType) {
    chartType = parsed.chartType
  }
  if (parsed.year) {
    year = parsed.year
  }
  if (parsed.rotateCharts) {
    chartTypesList = parsed.rotateCharts.split(",")
    type = chartTypesList[0]
    showLinks = false
    switchCharts = true
  }
  if (parsed.t) {
    timer = parsed.t * 1000
  }
  let d = new Date()
  let fills = ["#3484bd", "#1f6596", "#0b5488"]
  let fills2 = ["#bd343a", "#1f6596", "#0b5488"]
  let colors = ["#fefefe", "#fefefe", "#fefefe", "#fefefe"]

  let categoriesData = YearsWithMonths.KVMLMYears[
    YearsWithMonths.KVMLMYears.length - 1
  ].Months.map(function (month) {
    return month.monthtext
  })

  let months = YearsWithMonths.KVMLMYears[
    YearsWithMonths.KVMLMYears.length - 1
  ].Months.map(function (month) {
    return month.monthtext
  })

  let seriesData = YearsWithMonths.KVMLMYears[
    YearsWithMonths.KVMLMYears.length - 1
  ].Months.map(function (month) {
    return Math.round(month.KVMMonth)
  })

  let options = {
    series: [
      {
        data: seriesData,
      },
    ],
    chart: {
      height: "725px",
      type: chartType,
      id: "chart" + d.getMilliseconds(),
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    title: {
      text: `${title}`,
      align: "middle",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,

      style: {
        fontSize: "22px",
        fontWeight: "bold",
        fontFamily: "Julius Sans One",
        color: "#f3f3f3",
      },
    },
    grid: { show: false },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: "bottom",
        },
      },
    },
    dataLabels: {
      textAnchor: "start",
      style: {
        colors: colors,
      },
      hideOverflowingLabels: true,

      formatter: function (val, opts) {
        if (val > 0) {
          return `${val.toLocaleString()} ${mod}`
        }
      },
      /*textAnchor: "start",*/
      style: {
        fontSize: "14px",
        fontFamily: "Major Mono Display",
        fontWeight: "bold",
        colors: ["#fff"],
      },
      dropShadow: {
        enabled: false,
        top: 1,
        left: 1,
        blur: 1,
        color: "#000",
        opacity: 0.45,
      },
    },

    stroke: {
      show: true,
      width: 2,
      colors: ["#559ed6"],
      curve: "smooth",
    },
    fill: {
      colors: fills,
    },
    yaxis: {
      labels: {
        style: {
          colors: ["#fff"],
          fontSize: "16px",
          cssClass: "yaxis",
        },
      },
    },
    xaxis: {
      labels: {
        style: {
          colors: ["#fff"],
          fontSize: "16px",
          cssClass: "xaxis",
        },
        formatter: function (val, opts) {
          if (val > 0) {
            return `${val.toLocaleString()} ${mod}`
          }
        },
      },
      categories: categoriesData,
    },
  }
  function switchUs() {
    switch (type) {
      case "none":
        break
      case "M2":
        mod = "m²"
        const dataM2 = YearsWithMonths.KVMLMYears.filter(function (data) {
          return data.year == year
        })

        let M2Data = dataM2[0].Months.map(function (month) {
          return Math.round(month.KVMMonth)
        })

        seriesData = M2Data

        options.xaxis.categories = months

        options.title.text = `${mod} ${year}: ${Math.round(
          dataM2[0].KVMYear
        ).toLocaleString()} ${mod}`

        break
      case "M2GNSS":
        mod = "m²"
        const dataM2GNSS = YearsWithMonths.KVMLMYears.filter(function (data) {
          return data.year == year
        })

        let M2GNSS = dataM2GNSS[0].Months.map(function (month) {
          return Math.round(month.KVMGNSSMonth)
        })

        seriesData = M2GNSS
        options.xaxis.categories = months
        options.title.text = `GNSS ${year}: ${Math.round(
          dataM2GNSS[0].KVMGNSSYear
        ).toLocaleString()} ${mod}`
        break
      case "TotalLM":
        mod = "lm"
        const dataTotalLM = YearsWithMonths.KVMLMYears.filter(function (data) {
          return data.year == year
        })

        let TotalLM = dataTotalLM[0].Months.map(function (month) {
          return Math.round(month.TotalLMMonth)
        })

        seriesData = TotalLM
        options.xaxis.categories = months
        options.title.text = `LM ${year}: ${Math.round(
          dataTotalLM[0].TotalLMYear
        ).toLocaleString()} ${mod}`

        break
      case "TotalM2":
        mod = "m²"
        const dataTotalM2 = YearsWithMonths.KVMLMYears.filter(function (data) {
          return data.year == year
        })

        let TotalM2 = dataTotalM2[0].Months.map(function (month) {
          return Math.round(month.TotalKVMMonth)
        })

        seriesData = TotalM2
        options.xaxis.categories = months
        options.title.text = `M2 ${year}: ${Math.round(
          dataTotalM2[0].TotalKVMYear
        ).toLocaleString()} ${mod}`
        break

      case "TotalLMYear":
        mod = "lm"

        let dataTotalLMYear = AllYears.KVMLMYears.map(function (year) {
          return Math.round(year.TotalLMYear)
        })
        let categoriesTotalLMYear = AllYears.KVMLMYears.map(function (year) {
          return year.year
        })
        seriesData = dataTotalLMYear
        options.xaxis.categories = categoriesTotalLMYear
        options.title.text = "Total LM frest per år"

        break
      case "TotalM2Year":
        mod = "m²"
        let dataTotalM2Year = AllYears.KVMLMYears.map(function (year) {
          return Math.round(year.TotalKVMYear)
        })
        let categoriesTotalM2Year = AllYears.KVMLMYears.map(function (year) {
          return year.year
        })
        seriesData = dataTotalM2Year
        options.xaxis.categories = categoriesTotalM2Year
        options.title.text = "Total m² frest per år"

        break
      case "TotalM2MonthsYears":
        mod = "m²"

        let data1TotalM2MonthsYears = YearsWithMonths.KVMLMYears[
          YearsWithMonths.KVMLMYears.length - 1
        ].Months.map(function (year) {
          return Math.round(year.TotalKVMMonth)
        })
        let data2TotalM2MonthsYears = YearsWithMonths.KVMLMYears[
          YearsWithMonths.KVMLMYears.length - 2
        ].Months.map(function (year) {
          return Math.round(year.TotalKVMMonth)
        })
        let data3TotalM2MonthsYears = YearsWithMonths.KVMLMYears[
          YearsWithMonths.KVMLMYears.length - 3
        ].Months.map(function (year) {
          return Math.round(year.TotalKVMMonth)
        })

        let categoriesTotalM2MonthsYears = YearsWithMonths.KVMLMYears[0].Months.map(
          function (month) {
            return month.monthtext
          }
        )

        series[0] = {}
        series[1] = {}
        series[2] = {}
        series[0].data = data1TotalM2MonthsYears
        series[0].name =
          YearsWithMonths.KVMLMYears[YearsWithMonths.KVMLMYears.length - 1].year
        series[1].data = data2TotalM2MonthsYears
        series[1].name =
          YearsWithMonths.KVMLMYears[YearsWithMonths.KVMLMYears.length - 2].year
        series[2].data = data3TotalM2MonthsYears
        series[2].name =
          YearsWithMonths.KVMLMYears[YearsWithMonths.KVMLMYears.length - 3].year
        options2.xaxis.categories = categoriesTotalM2MonthsYears
        options2.title.text = "Total m² frest per år"

        break
      case "TotalLMMonthsYears":
        mod = "lm"

        let data1TotalLMMonthsYears = YearsWithMonths.KVMLMYears[
          YearsWithMonths.KVMLMYears.length - 1
        ].Months.map(function (year) {
          return Math.round(year.TotalLMMonth)
        })
        let data2TotalLMMonthsYears = YearsWithMonths.KVMLMYears[
          YearsWithMonths.KVMLMYears.length - 2
        ].Months.map(function (year) {
          return Math.round(year.TotalLMMonth)
        })
        let data3TotalLMMonthsYears = YearsWithMonths.KVMLMYears[
          YearsWithMonths.KVMLMYears.length - 3
        ].Months.map(function (year) {
          return Math.round(year.TotalLMMonth)
        })

        let categoriesTotalLMMonthsYears = YearsWithMonths.KVMLMYears[0].Months.map(
          function (month) {
            return month.monthtext
          }
        )

        series[0] = {}
        series[1] = {}
        series[2] = {}
        series[0].data = data1TotalLMMonthsYears
        series[0].name =
          YearsWithMonths.KVMLMYears[YearsWithMonths.KVMLMYears.length - 1].year
        series[1].data = data2TotalLMMonthsYears
        series[1].name =
          YearsWithMonths.KVMLMYears[YearsWithMonths.KVMLMYears.length - 2].year
        series[2].data = data3TotalLMMonthsYears
        series[2].name =
          YearsWithMonths.KVMLMYears[YearsWithMonths.KVMLMYears.length - 3].year
        options2.xaxis.categories = categoriesTotalLMMonthsYears
        options2.title.text = "Total LM frest per år"
        console.log(series)
        console.log(categoriesTotalLMMonthsYears)
        break
      default:

      // code block
    }
    options.series = [
      {
        name: "Kvadratmeter",
        data: seriesData,
      },
    ]
  }
  onMount(async () => {
    let api = "https://killingmoinfoapi.planleggern.no"
    let urls = [
      `${api}/statistikk/GetKVMLMCurrentYearWithMonths`,
      `${api}/statistikk/GetKVMLMAllYearsWithMonths`,
      `${api}/statistikk/GetKVMLMCurrentYear`,
      `${api}/statistikk/GetKVMLMAllYears`,
    ]

    // map every url to the promise of the fetch
    let requests = urls.map((url) => fetch(url))

    // Promise.all waits until all jobs are resolved
    Promise.all(requests)
      .then(function (responses) {
        // Get a JSON object from each of the responses
        return Promise.all(
          responses.map(function (response) {
            return response.json()
          })
        )
      })
      .then(function (data) {
        CurrentYearWithMonths = data[0]
        YearsWithMonths = data[1]
        CurrentYear = data[2]
        AllYears = data[3]
      })
      .then(function () {
        switchUs()
      })
      .catch(function (error) {
        // if there's an error, log it
        console.log(error)
      })
  })

  var options2 = {
    series: series,
    chart: {
      height: "725px",

      type: chartType,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    title: {
      text: `${title}`,
      align: "middle",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,

      style: {
        fontSize: "22px",
        fontWeight: "bold",
        fontFamily: "Julius Sans One",
        color: "#f3f3f3",
      },
    },
    grid: { show: false },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: "bottom",
        },
      },
    },
    dataLabels: {
      textAnchor: "start",
      style: {
        colors: colors,
      },
      hideOverflowingLabels: true,

      formatter: function (val, opts) {
        if (val > 0) {
          return `${val.toLocaleString()} ${mod}`
        }
      },
      /*textAnchor: "start",*/
      style: {
        fontSize: "11px",
        fontFamily: "Major Mono Display",
        fontWeight: "bold",
        colors: ["#fff"],
      },
      dropShadow: {
        enabled: false,
        top: 1,
        left: 1,
        blur: 1,
        color: "#000",
        opacity: 0.45,
      },
    },

    fill: {
      colors: fills2,
    },
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: "bottom",
      horizontalAlign: "center",
      floating: false,
      fontSize: "14px",
      fontFamily: "Helvetica, Arial",
      fontWeight: 400,
      formatter: undefined,
      inverseOrder: false,
      width: undefined,
      height: undefined,
      tooltipHoverFormatter: undefined,
      offsetX: 0,
      offsetY: 0,
      labels: {
        colors: fills,
        useSeriesColors: true,
      },
      markers: {
        width: 22,
        height: 22,
        strokeColor: "#fff",
        fillColors: fills2,
        radius: 0,
        customHTML: undefined,
        onClick: undefined,
        offsetX: 0,
        offsetY: 0,
      },
      itemMargin: {
        horizontal: 5,
        vertical: 0,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: ["#fff"],
          fontSize: "16px",
          cssClass: "yaxis",
        },
      },
    },
    xaxis: {
      labels: {
        style: {
          colors: ["#fff"],
          fontSize: "16px",
          cssClass: "xaxis",
        },

        formatter: function (val, opts) {
          if (val > 0) {
            return `${val.toLocaleString()} ${mod}`
          }
        },
      },
      categories: [],
    },
  }

  if (switchCharts) {
    let count = 0
    window.setInterval(function () {
      if (count >= chartTypesList.length - 1) {
        count = 0
      } else {
        count++
      }
      type = chartTypesList[count]
      switchUs()
    }, timer)
  }
</script>

<Router {routes} />

{#if showLinks}
  <a href="/?type=M2" target="_blank">M2</a><br /><br />
  <a href="/?type=M2GNSS" target="_blank">M2GNSS</a><br /><br />
  <a href="/?type=TotalLM" target="_blank">TotalLM</a><br /><br />
  <a href="/?type=TotalM2" target="_blank">TotalM2</a><br /><br />
  <a href="/?type=TotalLMYear" target="_blank">TotalLMYear</a><br /><br />
  <a href="/?type=TotalM2Year" target="_blank">TotalM2Year</a><br /><br />
  <a
    href="/?type=TotalM2MonthsYears"
    target="_blank">TotalM2MonthsYears</a><br /><br />
  <a
    href="/?type=TotalLMMonthsYears"
    target="_blank">TotalLMMonthsYears</a><br /><br /><br />
  <a href="/?type=M2&switchCharts=true" target="_blank">ROTERER IGJENNOM ALLE
    GRAFER</a><br /><br />
  <a href="/?rotateCharts=M2,TotalM2Year&t=5" target="_blank">Utvalg av grafer å
    rotere, og tid imellom visning</a>
{/if}
{#if type == 'TotalM2MonthsYears' || type == 'TotalLMMonthsYears'}
  <div use:chart={options2} />
{:else if type != 'none'}
  <div use:chart={options} />
{/if}
